<template>
  <vue-spinner
    :loading="loading"
    size="20px"
  />
</template>

<script>
import SyncLoader from 'vue-spinner/src/SyncLoader';

export default {
  components: {
    'vue-spinner': SyncLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.v-spinner {
  padding-bottom: 11px;
}
.v-spinner > * {
  background-color: $pink-100 !important;
}
</style>
